import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-main-screem',
  templateUrl: './loading-main-screem.component.html',
  styleUrls: ['./loading-main-screem.component.scss'],
  standalone: false
})
export class LoadingMainScreemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
